import { render, staticRenderFns } from "./table-cell-widget.vue?vue&type=template&id=be040a44&scoped=true"
import script from "./table-cell-widget.vue?vue&type=script&lang=js"
export * from "./table-cell-widget.vue?vue&type=script&lang=js"
import style0 from "./table-cell-widget.vue?vue&type=style&index=0&id=be040a44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be040a44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be040a44')) {
      api.createRecord('be040a44', component.options)
    } else {
      api.reload('be040a44', component.options)
    }
    module.hot.accept("./table-cell-widget.vue?vue&type=template&id=be040a44&scoped=true", function () {
      api.rerender('be040a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/table-cell-widget.vue"
export default component.exports